import { ChangeEvent, KeyboardEvent, useEffect, useState, forwardRef } from "react";
import styles from "./TextInput.module.css";

interface TextInputProps {
    id?: string;
    name?: string;
    placeholder?: string;
    value: string;
    onChange?: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    onClick?: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    isValid?: boolean;
    validMsg?: string;
    isDisabled?: boolean;
    type?: string;
    width?: string;
    fontSize?: string;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
    (
        {
            id,
            name,
            placeholder,
            value,
            onChange,
            onClick,
            onKeyDown,
            isValid = true, // 기본값 설정
            validMsg,
            isDisabled,
            type,
            width,
            fontSize,
        },
        ref
    ) => {
        return (
            <div className={`${styles.row} ${styles.feedback_container}`} style={{ width: width }}>
                <input
                    id={id}
                    type={type}
                    className={`${styles.form_control} ${!isValid ? styles.invalid : ""}`}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    disabled={isDisabled}
                    ref={ref}
                    style={{ fontSize: fontSize }}
                />
                {isValid == false && <span role="alert">{validMsg}</span>}
            </div>
        );
    }
);

export default TextInput;
